// extracted by mini-css-extract-plugin
export var copyright = "Copyright-module--copyright--LGAkk";